<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <Categories />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import Categories from "./components/Categories";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    Categories,
    // ProjectsTable,
  },
};

</script>
